import Polygon from "components/Navigation/Navigator/Polygon";

const Layers = (p5, s) => [
    [
        new Polygon(p5, 0, 0, s, "c_diatonic"),
        new Polygon(p5, 0, 0, s, "g_diatonic"),
        new Polygon(p5, 0, 0, s, "d_diatonic"),
        new Polygon(p5, 0, 0, s, "a_diatonic"),
        new Polygon(p5, 0, 0, s, "e_diatonic"),
        new Polygon(p5, 0, 0, s, "b_diatonic"),
        new Polygon(p5, 0, 0, s, "fs_diatonic"),
        new Polygon(p5, 0, 0, s, "cs_diatonic"),
        new Polygon(p5, 0, 0, s, "gs_diatonic"),
        new Polygon(p5, 0, 0, s, "ds_diatonic"),
        new Polygon(p5, 0, 0, s, "as_diatonic"),
        new Polygon(p5, 0, 0, s, "f_diatonic"),
    ],
    [
        new Polygon(p5, 0, 0, s, "c_acoustic"),
        new Polygon(p5, 0, 0, s, "g_acoustic"),
        new Polygon(p5, 0, 0, s, "d_acoustic"),
        new Polygon(p5, 0, 0, s, "a_acoustic"),
        new Polygon(p5, 0, 0, s, "e_acoustic"),
        new Polygon(p5, 0, 0, s, "b_acoustic"),
        new Polygon(p5, 0, 0, s, "fs_acoustic"),
        new Polygon(p5, 0, 0, s, "cs_acoustic"),
        new Polygon(p5, 0, 0, s, "gs_acoustic"),
        new Polygon(p5, 0, 0, s, "ds_acoustic"),
        new Polygon(p5, 0, 0, s, "as_acoustic"),
        new Polygon(p5, 0, 0, s, "f_acoustic"),
    ],
    [
        new Polygon(p5, 0, 0, s, "d_harmonic_minor"),
        new Polygon(p5, 0, 0, s, "d_harmonic_major"),
        new Polygon(p5, 0, 0, s, "b_harmonic_minor"),
        new Polygon(p5, 0, 0, s, "b_harmonic_major"),
        new Polygon(p5, 0, 0, s, "gs_harmonic_minor"),
        new Polygon(p5, 0, 0, s, "gs_harmonic_major"),
        new Polygon(p5, 0, 0, s, "f_harmonic_minor"),
        new Polygon(p5, 0, 0, s, "f_harmonic_major"),
    ],
    [
        {},
        new Polygon(p5, 0, 0, s, "a_harmonic_minor"),
        new Polygon(p5, 0, 0, s, "a_harmonic_major"),
        {},
        new Polygon(p5, 0, 0, s, "fs_harmonic_minor"),
        new Polygon(p5, 0, 0, s, "fs_harmonic_major"),
        {},
        new Polygon(p5, 0, 0, s, "ds_harmonic_minor"),
        new Polygon(p5, 0, 0, s, "ds_harmonic_major"),
        {},
        new Polygon(p5, 0, 0, s, "c_harmonic_minor"),
        new Polygon(p5, 0, 0, s, "c_harmonic_major"),
    ],
    [
        new Polygon(p5, 0, 0, s, "g_harmonic_major"),
        new Polygon(p5, 0, 0, s, "e_harmonic_minor"),
        new Polygon(p5, 0, 0, s, "e_harmonic_major"),
        new Polygon(p5, 0, 0, s, "cs_harmonic_minor"),
        new Polygon(p5, 0, 0, s, "cs_harmonic_major"),
        new Polygon(p5, 0, 0, s, "as_harmonic_minor"),
        new Polygon(p5, 0, 0, s, "as_harmonic_major"),
        new Polygon(p5, 0, 0, s, "g_harmonic_minor"),
    ],
    [
        new Polygon(p5, 0, 0, s, "hexatonic_4"),
        new Polygon(p5, 0, 0, s, "hexatonic_3"),
        new Polygon(p5, 0, 0, s, "hexatonic_2"),
        new Polygon(p5, 0, 0, s, "hexatonic_1"),
    ],
    [
        {},
        new Polygon(p5, 0, 0, s, "octatonic_3"),
        {},
        new Polygon(p5, 0, 0, s, "octatonic_2"),
        {},
        new Polygon(p5, 0, 0, s, "octatonic_1"),
    ],
    [
        {},
        new Polygon(p5, 0, 0, s, "whole_tone_2"),
        {},
        new Polygon(p5, 0, 0, s, "whole_tone_1"),
    ],
];

export default Layers;
